module.exports = __webpack_public_path__ + "static/scoring-img-176008f53cdd6a6c2874240248519eb9.png";